/**
 * @desc 获取模板详情
 */
import {
  TemplateEntity,
  QueryTemplateParam
} from '@eastcoal/api/contract/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryTemplateParameter = QueryTemplateParam

const method = 'GET'
const url = '/contract/template'

export const queryTemplateApi = (
  params?: QueryTemplateParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<TemplateEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryTemplateApi.method = method
queryTemplateApi.url = url
